export default "__VITE_ASSET__D8Vpgp1B__"